function updateTimers() {
    const timers = document.querySelectorAll(".timer");

    timers.forEach(timer => {
        const now = new Date().getTime();
        const distance = deadline - now;

        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        timer.innerHTML = (hours < 10 ? "0" + hours : hours) + ":" +
                          (minutes < 10 ? "0" + minutes : minutes) + ":" +
                          (seconds < 10 ? "0" + seconds : seconds);

        if (distance < 0) {
          clearInterval(countdown);
          timer.innerHTML = "00:00:00";
        }
    });
}

const deadline = new Date().getTime() + (1 * 60 * 60 + 17 * 60 + 39) * 1000;
const countdown = setInterval(updateTimers, 1000);
updateTimers();


